import { STATIC_ROUTES } from "nodes/codex/CodexRoutes";

export enum POST_INDEX {
  BLOG_INTRODUCE_CARD_MEMOIR = 0,
  BLOG_COMMUNITIES_TEMPLATE_DECK = 1,
  BLOG_DRAWING_CHALLENGE_CARD = 2,
  BLOG_ORDER_PHYSICAL_PRINTS = 3,
}

export type BlogPost = {
  imgSrc: string;
  imgSize: number;
  name: string;
  route: STATIC_ROUTES;
  date: string;
};
